import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function SalesLogin() {
  const nav = useNavigate();
  const { loginSales } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginSales(email.trim().toLowerCase(), password);
      toast.success("Welcome, Sales Team");
      nav("/sales");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-10"><BrandMark subtitle="SALES TEAM" /></div>
        <div className="p-8 rounded-sm border" style={{ borderColor: "var(--border)", background: "var(--surface)" }}>
          <div className="overline mb-2">Sign in</div>
          <h1 className="font-heading text-3xl mb-6">Sales access</h1>
          <p className="text-sm text-white/50 mb-5">
            Customer pickup, invoice access and component issue resolution.
          </p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="overline">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="sales-email-input"
                className="mt-2 bg-black border-white/20 text-white h-11"
              />
            </div>
            <div>
              <Label htmlFor="password" className="overline">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="sales-password-input"
                className="mt-2 bg-black border-white/20 text-white h-11"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="sales-login-submit"
              className="w-full h-11 rounded-sm font-medium"
              style={{ background: "var(--accent)", color: "#000" }}
            >
              {loading ? "Signing in…" : "Continue"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
